import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class SuccessMetric extends Field {
  static attributesForModel() {
    return ['metricName'];
  }

  get title() {
    return 'Success metric';
  }

  exampleContents(): FieldContentsData {
    return {
      text: `Example success metric`,
    };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.metricName };
  }
}
